var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"z-badge relative inline-block"},[_vm._t("default"),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden && (_vm.content || _vm.content === 0 || _vm.isDot)),expression:"!hidden && (content || content === 0 || isDot)"}],staticClass:"z-badge-content transform text-center",class:[
      _vm.bgColor,
      _vm.sizeClasses,
      !_vm.isNotification && _vm.positionClasses,
      _vm.isNotification && _vm.notificationClasses,
      !_vm.isDot && _vm.typeClasses,
      `text-${_vm.textColor}`,
      {
        'absolute -translate-y-1/2 translate-x-1/2': !_vm.isNotification,
        'rounded-full p-0': !_vm.isNotification && _vm.isDot,
        'rounded-full leading-4': _vm.value
      }
    ]},[_c('span',[_vm._v(_vm._s(_vm.content))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }